// components/EquipmentCard.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const EquipmentCard = ({ id, image, title, subtitle, price }) => {
  const navigate = useNavigate();

  const handleDetailsClick = () => {
    navigate(`/equipement/${id}`);
  };

  return (
    <div className='equipment-card position-relative overflow-hidden'>
      <img
        src={image}
        className='img-fluid w-100 h-100 object-fit-cover'
        alt={title}
        style={{ maxHeight: '250px' }}
      />
      <div className='equipment-content position-absolute w-100 px-3 py-2 text-white'>
        <div className='equipment-overlay'>
          <h5 className='fw-bold mb-1'>{title}</h5>
          <h6 className='mb-1'>{subtitle}</h6>
          <p className='mb-2'>{price}</p>
          <button onClick={handleDetailsClick} className='btn btn-warning btn-sm'>
            Voir détails
          </button>
        </div>
      </div>

    </div>
  );
};
export default EquipmentCard